import Splide from '@splidejs/splide';
import { Translations } from '../utils';
import './notizie-correlate-slider.scss';

export class NotizieSlider {
  constructor() {
    this.els = document.querySelectorAll('.js-notizie-slider');
    if (!this.els.length) return;

    this.init();
  }

  init() {
    this.els.forEach((el) => {
      const splide = new Splide(el, {
        type: 'slide',
        arrows: true,
        pagination: false,
        gap: '1.5rem',
        perPage: 3,
        focus: 0,
        trimSpace: true,
        snap: true,
        breakpoints: {
          992: {
            perPage: 2.2,
          },
          767: {
            perPage: 1.2,
          },
        },
        i18n: Translations.getSplideI18n(),
      });

      splide.mount();

      const next = el.querySelector('.splide__arrow--next');

      const updateArrows = () => {
        if (!window.matchMedia('(min-width: 992px)').matches) return;

        const { index } = splide;
        const last = splide.length - splide.options.perPage;
        // Se sono all’ultima slide disabilito next
        if (index >= last) {
          next.classList.add('is-disabled');
        } else {
          next.classList.remove('is-disabled');
        }
      };

      updateArrows();
      splide.on('mounted move', updateArrows);
    });
  }
}
